export interface FormTagListStyling {
    style: FormTagListStyle;
    modifiers: FormTagListStyleModifier[];
    color?: FormTagListTagColor;
}

export enum FormTagListStyle {
    Default = 'Default',
    Embedded = 'Embedded'
}

export enum FormTagListStyleModifier {
    NoBorder = '-sh-remove-border'
}

export enum FormTagListTagColor {
    Default = 'sh-tag',
    Red = 'sh-tag--error',
    Orange = 'sh-tag--warning',
    Green = 'sh-tag--success',
    Blue = 'sh-tag--update',
    Brand = 'sh-tag--brand'
}
